import { useInView } from '../../../hooks/useInView';

const benefits = [
  {
    icon: 'ri-leaf-line',
    title: 'Ingredientes Naturais',
    description: 'Utilizamos extratos botânicos selecionados da biodiversidade brasileira, sem ingredientes artificiais prejudiciais à pele.',
  },
  {
    icon: 'ri-heart-line',
    title: 'Cruelty Free',
    description: 'Nossos produtos nunca são testados em animais. Beleza ética é um compromisso inegociável da nossa marca.',
  },
  {
    icon: 'ri-microscope-line',
    title: 'Dermatologicamente Testado',
    description: 'Cada fórmula passa por rigorosos testes dermatológicos para garantir segurança para todos os tipos de pele.',
  },
  {
    icon: 'ri-flask-line',
    title: 'Fórmulas Exclusivas',
    description: 'Desenvolvemos patentes próprias com tecnologias inovadoras que potencializam a absorção e eficácia dos ativos.',
  },
  {
    icon: 'ri-award-line',
    title: 'Resultados Comprovados',
    description: 'Estudos clínicos independentes comprovam a eficácia dos nossos produtos, com resultados visíveis em 14 dias.',
  },
  {
    icon: 'ri-recycle-line',
    title: 'Embalagens Sustentáveis',
    description: 'Todas as nossas embalagens são fabricadas com materiais reciclados e 100% recicláveis, cuidando do planeta.',
  },
];

export default function BenefitsSection() {
  const { ref, inView } = useInView();

  return (
    <section id="beneficios" className="py-24 bg-[#F5F5F5]">
      <div ref={ref} className="max-w-7xl mx-auto px-6 lg:px-10">
        {/* Header */}
        <div className={`text-center mb-16 ${inView ? 'animate-fade-in-up' : 'opacity-0-init'}`}>
          <p className="text-[#0F7C7A] text-sm font-semibold tracking-[0.2em] uppercase mb-3">
            Por Que Nos Escolher
          </p>
          <h2 className="font-display text-4xl lg:text-5xl text-[#1A1A1A] font-bold mb-4">
            Nossos Diferenciais
          </h2>
          <p className="text-[#555555] text-base max-w-lg mx-auto leading-relaxed">
            Comprometidas com sua beleza e bem-estar, entregamos qualidade superior em cada produto que criamos.
          </p>
        </div>

        {/* Benefits Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits.map((benefit, idx) => (
            <div
              key={benefit.title}
              className={`group bg-white rounded-2xl p-8 border border-[#DFF0F0] hover:border-[#0F7C7A]/40 transition-all duration-400 ${
                inView ? `animate-fade-in-up delay-${Math.min(idx * 100, 500)}` : 'opacity-0-init'
              }`}
            >
              <div className="w-14 h-14 flex items-center justify-center bg-[#E0F5F5] group-hover:bg-[#0F7C7A] rounded-2xl mb-5 transition-colors duration-300">
                <i className={`${benefit.icon} text-2xl text-[#0F7C7A] group-hover:text-white transition-colors duration-300`} />
              </div>
              <h3 className="font-display text-xl font-semibold text-[#1A1A1A] mb-3">
                {benefit.title}
              </h3>
              <p className="text-[#555555] text-sm leading-relaxed">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>

        {/* Banner */}
        <div
          className={`mt-16 rounded-3xl overflow-hidden relative ${
            inView ? 'animate-fade-in-up delay-600' : 'opacity-0-init'
          }`}
        >
          <img
            src="https://storage.readdy-site.link/project_files/bc073682-be8a-41b0-bc42-811cad36305d/5c036e98-b841-45a8-9fd4-138371190bc7_Screen-Shot-2026-03-21-at-4.20.57-PM.png"
            alt="Beleza natural"
            className="w-full h-48 lg:h-64 object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-[#0F7C7A]/80 via-[#0F7C7A]/60 to-transparent flex items-center px-10 lg:px-16">
            <div className="max-w-lg">
              <h3 className="font-display text-2xl lg:text-3xl text-white font-bold mb-3">
                Rotina de Beleza Completa
              </h3>
              <p className="text-white/85 mb-5 text-sm leading-relaxed">
                Descubra como combinar nossos produtos para uma rotina perfeita de cuidados com a pele.
              </p>
              <button
                onClick={() => document.getElementById('contato')?.scrollIntoView({ behavior: 'smooth' })}
                className="bg-white text-[#0F7C7A] font-semibold px-7 py-3 rounded-full hover:bg-[#E0F5F5] transition-colors cursor-pointer whitespace-nowrap text-sm"
              >
                Falar com Especialista
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
